import { ApiService }     from '../../app-lite/api/api.service';
import { CodeTypeModel }     from '../../app-lite/core/models/code-type';
import { SessionService } from '../../app-lite/sessions/session.service';

import BookingDiaryHtml from './booking-diary.html';

export function BookingStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'BookingDiaryCtrl',
    name      : 'app.booking-diary',
    params    : {
      view: { squash: true, value: null }
    },
    reloadOnSearch: false,
    templateUrl   : BookingDiaryHtml,
    url           : '/booking-diary?view&group_index&date&mechanic&mechanicId&viewSingleMechanic',
    resolve       : {
      bookingRequests: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/event_requests/count'),
      jobStatusTypes : ( workshopAPI : ApiService ) : ng.IPromise<Array<CodeTypeModel>> => workshopAPI.get('/system/job_status_types'),
      settings       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      groups         : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService, sessionObjAPI : SessionService) : ng.IPromise<any> => {
        const company = sessionObjAPI.company();
        let   records = 10;

        if ($stateParams.view === 'day') {
          records = company.company_settings.booking_calendar_maximum_mechanics
            ? company.company_settings.booking_calendar_maximum_mechanics
            : 5;
        }

        return workshopAPI.get('/system/mechanic_grouping_for_filter', [ records, $stateParams.date ]);
      }
    }
  });
}